import React from "react"
import PropTypes from "prop-types"

class WeeklyWritingTextArea extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      text: '',
      title: ''
    }
    this.onChange = this.onChange.bind(this)
    this.titleText = this.titleText.bind(this)
  }

  onChange(event) {
    this.props.updateWritingText(event.target.value)
  }

  componentDidMount() {
    if(this.props.topic != undefined) {
      this.setState({
        title: this.props.topic.title
      })
    } else {
      //ajax call to get topic information
    }
  }

  titleText() {
    if(this.props.writeMoreError === true) {
      return(<p className="lex-alert lex-alert--error" style={{ textAlign: 'center', marginBottom: 12 }}>Try writing a little more...</p>)
    }
    return(<p className="lex-alert lex-alert--success" style={{ textAlign: 'center', marginBottom: 12 }}>{this.state.title}</p>)

  }


  render() {
    return(
      <div className="lex-dash-field">
        {this.titleText()}
        <textarea
          className="lex-dash-field__textarea"
          onChange={this.onChange}
          value={this.props.text}
          placeholder={this.props.placeholder}
          rows={8}
        />
      </div>
    )
  }

}

export default WeeklyWritingTextArea;
